export const baseImageUrl = 'https://datapadassets.blob.core.windows.net';
//# sourceMappingURL=Constants.js.map